import React from 'react';
import PrivacyAssessment from './components/PrivacyAssessment.jsx';
import { Shield } from 'lucide-react';

function App() {
  return (
    <div className="min-h-screen bg-stone-200 py-8">
      <div className="max-w-5xl mx-auto px-4">
        <header className="mb-8 text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Shield className="h-8 w-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-800">Privacy Assessment Tool</h1>
          </div>
          <p className="text-gray-600">Evaluate your digital privacy vulnerability and get personalized recommendations</p>
        </header>
        
        <main>
          <PrivacyAssessment />
        </main>
      </div>
    </div>
  );
}

export default App; 